import React from "react";
import {
  FormControl,
  FormLabel,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  styled,
} from "@mui/material";
import { Controller } from "react-hook-form";

const StyledRadio = styled(Radio)`
  &.Mui-checked {
    color: #3a3a3a;
  }
`;

const ReactRadio = (props) => {
  const {
    hookFormControl,
    label,
    varName,
    options = [],
    errorMessage = null,
    orientation = "horizontal" | "vertical",
    size = "medium",
    width = "100%",
    withMessage = true,
  } = props;

  return (
    <FormControl
      error={errorMessage !== null}
      sx={{ width }}
      component="fieldset"
      size={size}
    >
      {label && (
        <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">
          {label}
        </FormLabel>
      )}
      <Controller
        name={varName}
        control={hookFormControl}
        render={({ field }) => (
          <RadioGroup
            name={field.name}
            value={field.value ?? ""}
            onChange={field.onChange}
            row={orientation === "horizontal"}
          >
            {options.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option.value}
                control={<StyledRadio />}
                label={option.label}
                className="font-['Poppins-Regular'] text-[15px]"
              />
            ))}
          </RadioGroup>
        )}
      />
      {errorMessage && withMessage && (
        <FormHelperText
          className="ml-0 font-['Poppins-Regular']"
          id="component-error-text"
        >
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ReactRadio;
